import type { StrapiApp } from '@strapi/strapi/admin';

export default {
  config: {
    locales: [
      // 'ar',
      // 'fr',
      // 'cs',
      // 'de',
      // 'dk',
      'es',
      // 'he',
      // 'id',
      // 'it',
      // 'ja',
      // 'ko',
      // 'ms',
      // 'nl',
      // 'no',
      // 'pl',
      // 'pt-BR',
      'pt',
      // 'ru',
      // 'sk',
      // 'sv',
      // 'th',
      // 'tr',
      // 'uk',
      // 'vi',
      // 'zh-Hans',
      // 'zh',
    ],
    translations: {
      en: {
        "content-manager.plugin.name": "QR Code Generator",
        "cloud.plugin.name": "Cloud Plugin Name",
        "story": "Story",
        "IntlError2": "IntlError2",
        "User": "User",
        "Storytellers Contents": "Storytellers Contents",
        "content-manager.content-types.api::story.story.title": "Story Title",
        "content-manager.content-types.api::story.story.country": "Country",
        "content-manager.content-types.api::story.story.stages": "Stages",
        "content-manager.content-types.api::story.story.header": "Header", // Added missing translation
        "content-manager.content-types.api::story.story.imageHeader": "Image Header", // Added missing translation
        "content-manager.components.stage.stage.url": "URL", // Added missing translation
        "content-manager.components.stage.stage.title": "Stage Title", // Added missing translation
        "content-manager.components.stage.stage.gps": "GPS", // Added missing translation
        "content-manager.components.stage.stage.position": "Position", // Added missing translation
        "content-manager.components.stage.stage.image": "Image", // Added missing translation
        "content-manager.components.stage.stage.video": "Video", // Added missing translation
        "content-manager.components.stage.stage.Gltf": "Gltf", // Added missing translation
        "content-manager.components.stage.stage.mapIcon": "Map Icon", // Added missing translation
        "content-manager.components.stage.stage.header": "Header", // Added missing translation
        "content-manager.components.stage.stage.imageHeader": "Image Header", // Added missing translation
        "content-manager.components.stage.stage.description": "Description", // Added missing translation
        "content-manager.components.stage.stage.audio": "Audio", // Added missing translation
        "content-manager.components.stage.stage.contents": "Contents", // Added missing translation
        "content-manager.components.stage.stage.additional": "Additional", // Added missing translation
        "content-manager.components.stage.stage.qrcode": "QR Code", // Added missing translation
        "content-manager.components.Blocks.dnd.instruction": "To reorder blocks, press Command or Control along with Shift and the Up or Down arrow keys", // Added missing translation
        "content-manager.components.Blocks.expand": "Expand", // Added missing translation
        "i18n.list-view.table.header.label": "Available in", // Added missing translation
        "content-manager.containers.list.table-headers.status": "Status", // Added missing translation
        "content-manager.content-types.api::story.story.id": "ID", // Added missing translation
        "content-manager.content-types.api::story.story.slug": "Slug", // Added missing translation
        "content-manager.actions.unpublish.dialog.radio-label": "Choose an option to unpublish the document.", // Added missing translation
        "app.components.HomePage.community.links.github": "Github", // Added missing translation
        "app.components.HomePage.community.links.discord": "Discord", // Added missing translation
        "app.components.HomePage.community.links.reddit": "Reddit", // Added missing translation
        "app.components.HomePage.community.links.twitter": "Twitter", // Added missing translation
        "app.components.HomePage.community.links.forum": "Forum", // Added missing translation
        "app.components.HomePage.community.links.blog": "Blog", // Added missing translation
        "app.components.HomePage.community.links.career": "We are hiring!", // Added missing translation
        "strapi-plugin-qrcode.form.margin.description": "El número de módulos a usar para el margen (predeterminado: 4)", // Added missing translation
        "strapi-plugin-qrcode.form.marginsize.label": "Tamaño del Margen", // Added missing translation
        "review-workflows.plugin.name": "Flujos de Trabajo de Revisión", // Added missing translation
        "strapi-plugin-qrcode.plugin.name": "Generador de Código QR", // Added missing translation
        "strapi-plugin-qrcode.form.size.label": "Tamaño del Código QR", // Added missing translation
        "strapi-plugin-qrcode.form.level.label": "Nivel de Corrección de Errores", // Added missing translation
      },
      es: {
        "content-manager.plugin.name": "Generador de código QR",
        "cloud.plugin.name": "Nombre del plugin de la nube",
        "story": "Historia",
        "IntlError2": "ErrorIntl2",
        "User": "Usuario",
        "Storytellers Contents": "Contenidos de los Cuentacuentos",
        "content-manager.content-types.api::story.story.title": "Título de la Historia",
        "content-manager.content-types.api::story.story.country": "País",
        "content-manager.content-types.api::story.story.stages": "Etapas",
        "content-manager.content-types.api::story.story.header": "Cabecera", // Added missing translation
        "content-manager.content-types.api::story.story.imageHeader": "Imagen de Cabecera", // Added missing translation
        "content-manager.components.stage.stage.url": "URL", // Added missing translation
        "content-manager.components.stage.stage.title": "Título de la Etapa", // Added missing translation
        "content-manager.components.stage.stage.gps": "GPS", // Added missing translation
        "content-manager.components.stage.stage.position": "Posición", // Added missing translation
        "content-manager.components.stage.stage.image": "Imágenes", // Added missing translation
        "content-manager.components.stage.stage.video": "Vídeo", // Added missing translation
        "content-manager.components.stage.stage.Gltf": "Gltf", // Added missing translation
        "content-manager.components.stage.stage.mapIcon": "Ícono del Mapa", // Added missing translation
        "content-manager.components.stage.stage.header": "Encabezado", // Added missing translation
        "content-manager.components.stage.stage.imageHeader": "Imagen de Encabezado", // Added missing translation
        "content-manager.components.stage.stage.description": "Descripción", // Added missing translation
        "content-manager.components.stage.stage.audio": "Audio", // Added missing translation
        "content-manager.components.stage.stage.contents": "Contenidos", // Added missing translation
        "content-manager.components.stage.stage.additional": "Adicional", // Added missing translation
        "content-manager.components.stage.stage.qrcode": "Código QR", // Added missing translation
        "content-manager.components.Blocks.dnd.instruction": "Para reordenar bloques, presione Comando o Control junto con Shift y las teclas de flecha hacia arriba o hacia abajo", // Added missing translation
        "content-manager.components.Blocks.expand": "Expandir", // Added missing translation
        "i18n.list-view.table.header.label": "Disponible en", // Added missing translation
        "content-manager.containers.list.table-headers.status": "Estado", // Added missing translation
        "content-manager.content-types.api::story.story.id": "ID", // Added missing translation
        "content-manager.content-types.api::story.story.slug": "Slug", // Added missing translation
        "content-manager.actions.unpublish.dialog.radio-label": "Elija una opción para despublicar el documento.", // Added missing translation
        "app.components.HomePage.community.links.github": "Github", // Added missing translation
        "app.components.HomePage.community.links.discord": "Discord", // Added missing translation
        "app.components.HomePage.community.links.reddit": "Reddit", // Added missing translation
        "app.components.HomePage.community.links.twitter": "Twitter", // Added missing translation
        "app.components.HomePage.community.links.forum": "Foro", // Added missing translation
        "app.components.HomePage.community.links.blog": "Blog", // Added missing translation
        "app.components.HomePage.community.links.career": "Estamos contratando!", // Added missing translation
        "strapi-plugin-qrcode.form.margin.description": "El número de módulos a usar para el margen (predeterminado: 4)", // Added missing translation
        "strapi-plugin-qrcode.form.marginsize.label": "Tamaño del Margen", // Added missing translation
        "review-workflows.plugin.name": "Flujos de Trabajo de Revisión", // Added missing translation
        "strapi-plugin-qrcode.plugin.name": "Generador de Código QR", // Added missing translation
        "strapi-plugin-qrcode.form.size.label": "Tamaño del Código QR", // Added missing translation
        "strapi-plugin-qrcode.form.level.label": "Nivel de Corrección de Errores", // Added missing translation
      },
      pt: {
        "content-manager.plugin.name": "Gerador de Código QR",
        "cloud.plugin.name": "Nome do plugin da nuvem",
        "story": "História",
        "IntlError2": "ErroIntl2",
        "User": "Usuário",
        "Storytellers Contents": "Conteúdos dos Contadores de Histórias",
        "content-manager.content-types.api::story.story.title": "Título da História",
        "content-manager.content-types.api::story.story.country": "País",
        "content-manager.content-types.api::story.story.stages": "Estágios",
        "content-manager.content-types.api::story.story.header": "Cabeçalho", // Added missing translation
        "content-manager.content-types.api::story.story.imageHeader": "Imagem de Cabeçalho", // Added missing translation
        "content-manager.components.stage.stage.url": "URL", // Added missing translation
        "content-manager.components.stage.stage.title": "Título da Etapa", // Added missing translation
        "content-manager.components.stage.stage.gps": "GPS", // Added missing translation
        "content-manager.components.stage.stage.position": "Posição", // Added missing translation
        "content-manager.components.stage.stage.image": "Imagem", // Added missing translation
        "content-manager.components.stage.stage.video": "Vídeo", // Added missing translation
        "content-manager.components.stage.stage.Gltf": "Gltf", // Added missing translation
        "content-manager.components.stage.stage.mapIcon": "Ícone do Mapa", // Added missing translation
        "content-manager.components.stage.stage.header": "Cabeçalho", // Added missing translation
        "content-manager.components.stage.stage.imageHeader": "Imagem de Cabeçalho", // Added missing translation
        "content-manager.components.stage.stage.description": "Descrição", // Added missing translation
        "content-manager.components.stage.stage.audio": "Áudio", // Added missing translation
        "content-manager.components.stage.stage.contents": "Conteúdos", // Added missing translation
        "content-manager.components.stage.stage.additional": "Adicional", // Added missing translation
        "content-manager.components.stage.stage.qrcode": "Código QR", // Added missing translation
        "content-manager.components.Blocks.dnd.instruction": "Para reordenar bloques, presione Comando o Control junto con Shift y las teclas de flecha hacia arriba o hacia abajo", // Added missing translation
        "content-manager.components.Blocks.expand": "Expandir", // Added missing translation
        "i18n.list-view.table.header.label": "Disponível em", // Added missing translation
        "content-manager.containers.list.table-headers.status": "Status", // Added missing translation
        "content-manager.content-types.api::story.story.id": "ID", // Added missing translation
        "content-manager.content-types.api::story.story.slug": "Slug", // Added missing translation
        "content-manager.actions.unpublish.dialog.radio-label": "Escolha uma opção para despublicar o documento.", // Added missing translation
        "app.components.HomePage.community.links.github": "Github", // Added missing translation
        "app.components.HomePage.community.links.discord": "Discord", // Added missing translation
        "app.components.HomePage.community.links.reddit": "Reddit", // Added missing translation
        "app.components.HomePage.community.links.twitter": "Twitter", // Added missing translation
        "app.components.HomePage.community.links.forum": "Fórum", // Added missing translation
        "app.components.HomePage.community.links.blog": "Blog", // Added missing translation
        "app.components.HomePage.community.links.career": "Estamos contratando!", // Added missing translation
      },  
    },
  },
  bootstrap(app: StrapiApp) {
    console.log(app);
  },
};
